import uuid from 'react-native-uuid';
import { PLATFORM } from "../../constants";

export const getDeviceId = async () => {
    const deviceId = uuid.v4().toString()
    return deviceId
};

export const getPlatform = () => {
    return PLATFORM // web / windows
}

export const isElectron = () => {
    return typeof window !== 'undefined'
        && (window as any).electron
        && (window as any).electron.isElectron === true;
};

export const isDesktop = () => {
    return isElectron();
};

export const shouldUseLocalProcessing = (
    preferredProcessingMode?: string,
    isOnline: boolean = true
) => {
    if (!isElectron()) {
        return false;
    }
    // Desktop offline mode: always allow local processing when offline,
    // regardless of the user's cloud/local preference.
    if (!isOnline) return true;
    if (preferredProcessingMode === 'local') return true;
    if (preferredProcessingMode === 'cloud') return false;
    // Back-compat: treat legacy "auto" as local.
    if (preferredProcessingMode === 'auto') return true;
    return false;
};
